import { SelectField } from '@mi-front/ui';
import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { getGipStationIds } from '../get-gip-station-ids';
import { useGipCampaignsQuery } from '../hooks/useGipCampaignsQuery';
import { GipReportValues } from '../types';

/** Campaigns multi-select, loaded from GIP metadata for the selected advertisers. */
export function CampaignsField() {
  const { $t } = useIntl();
  const { values } = useFormikContext<GipReportValues>();
  const queryEnabled = !!values.advertisers.length;

  const query = useGipCampaignsQuery(
    {
      from: values.from,
      to: values.to,
      stations: getGipStationIds(values),
      advertisers: values.advertisers.map((v) => v.name),
    },
    queryEnabled,
  );

  return (
    <SelectField
      name="campaigns"
      label={$t({
        id: 'audit.gipReport.form.campaigns',
        defaultMessage: 'Campañas',
      })}
      placeholder={$t({
        id: 'audit.gipReport.form.allCampaigns',
        defaultMessage: 'Todas las campañas',
      })}
      options={query.data?.map((name) => ({ name }))}
      multiple
      isClearable
      isSearchable
      getOptionLabel={(value) => value.name}
      getOptionValue={(value) => value.name}
      isLoading={query.isFetching}
    />
  );
}
